import AbstractMetricProtocol from '@/app/modules/Metrics/classes/AbstractMetricProtocol';
import { send } from '../adapters/YandexMetrika';

export default class YandexMetrikaProtocol extends AbstractMetricProtocol {
    public send() {
        let { value } = this;

        if (this.extraEventData.layer) {
            value = { [this.extraEventData.layer]: value };
        }

        send(value);
    }
}
